import { render, staticRenderFns } from "./LeavePeriods.vue?vue&type=template&id=8b1a25d6"
import script from "./LeavePeriods.vue?vue&type=script&lang=js"
export * from "./LeavePeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports